export default __webpack_public_path__ + "static/media/image1.17e4d373.jpg";